import { createFileRoute } from '@tanstack/react-router';
import { AffiliatesPage } from '../../pages/AffiliatesPage';
import { staticPageHead } from '../../lib/seo/staticPageHead';
import {
  COMMISSION_RATE,
  CREDIT_PREMIUM,
  WINDOW_MONTHS,
} from '../../lib/affiliateProgram';

export const Route = createFileRoute('/_site/affiliates')({
  head: () =>
    staticPageHead({
      path: '/affiliates',
      title: 'Affiliate Program - AnyAPI',
      // Composed from the same constants the page renders. A meta description
      // is the one copy a search result shows, so a figure hardcoded here
      // would be the version the world reads after the offer changed.
      description:
        `Earn ${COMMISSION_RATE} of every wallet top-up your referrals make for their first ` +
        `${WINDOW_MONTHS} months. Paid in cash by PayPal or Wise, or in AnyAPI credit at ` +
        `${CREDIT_PREMIUM} more.`,
      crumb: 'Affiliate Program',
    }),
  component: AffiliatesPage,
});
